// extracted by mini-css-extract-plugin
module.exports = {"container":"e_zp","textBadge":"e_Ap","buttonBlock":"e_Bp"};